export { setAssetPath } from "@esri/calcite-components/dist/components";

export * from "./components";
export * as Utils from "./utils";

console.log("LIB BUILD: #{BuildId}#");
